export default {
    install(Vue) {
        Vue.prototype.$useTheme = function () {
            const theme = localStorage.getItem('user-theme');
            return theme
        }
    }
}
